import PatientDetailsSelect from './PatientDetailsSelect';
import PatientRegistered from './PatientRegistered';
import PatientInvited from './PatientInvited';
import {
  BulkEmaiUserSelectionProps,
  FiltersState,
} from '../interface/interface';

const BulkEmailUserSelection = (props: BulkEmaiUserSelectionProps) => {
  return (
    <>
      <div className="grid grid-row-3 gap-3">
        <PatientDetailsSelect
          filters={props.filters}
          setFilters={props.setFilters}
        />
        <div>
          <label className="flex items-center space-x-3 mb-2">
            <input
              type="checkbox"
              name="invited"
              id="invited"
              className={`form-checkbox h-5 w-5 text-primary-blue-500 mt-1 cursor-pointer`}
              checked={props.filters?.ignoreIfAlreadySent}
              onChange={() =>
                props.setFilters((prev: FiltersState | undefined) => ({
                  ...prev!,
                  ignoreIfAlreadySent: !prev?.ignoreIfAlreadySent,
                }))
              }
            />
            <span className={`text-md text-primary-blue-500 cursor-pointer`}>
              Ignore if already sent
            </span>
          </label>
        </div>
        <PatientRegistered
          filters={props.filters}
          setFilters={props.setFilters}
        />
        <PatientInvited filters={props.filters} setFilters={props.setFilters} />
      </div>
    </>
  );
};

export default BulkEmailUserSelection;
